export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11279.23ecd9b2.jpg";